// Central content + config for the RenewTracker marketing site.
export const SUPPORT_EMAIL = "support@renewtracker.site";

export const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_2ed80847-c702-45f3-af8a-4ae552050a30/artifacts/ka6nrr0w_RenewTracker%20Logo2.png";

// Real RenewTracker app screenshots.
export const APP_SCREENSHOTS = {
  dashboard:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_renewtracker-landing/artifacts/ivbgnn4w_WhatsApp%20Image%202026-08-05%20at%2015.07.08.jpeg",
  items:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_renewtracker-landing/artifacts/v3ahuysp_WhatsApp%20Image%202026-08-05%20at%2015.01.52.jpeg",
  login:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_renewtracker-landing/artifacts/fvu6hpt8_WhatsApp%20Image%202026-08-05%20at%2015.07.35.jpeg",
  signup:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_renewtracker-landing/artifacts/s95vh0g2_WhatsApp%20Image%202026-08-05%20at%2015.07.54.jpeg",
  // Editorial (non-app) imagery used in supporting sections.
  documents:
    "https://images.unsplash.com/photo-1768158989131-64cbff67f292?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  smb_owner_1:
    "https://images.pexels.com/photos/36729739/pexels-photo-36729739.jpeg?auto=compress&cs=tinysrgb&w=800",
  smb_owner_2:
    "https://images.pexels.com/photos/8475171/pexels-photo-8475171.jpeg?auto=compress&cs=tinysrgb&w=800",
};

export const CATEGORIES = [
  { name: "Vehicle Insurance", icon: "ShieldCheck" },
  { name: "Road Tax", icon: "ReceiptText" },
  { name: "Pollution Certificates", icon: "Leaf" },
  { name: "Driving Licences", icon: "CreditCard" },
  { name: "Commercial Permits", icon: "FileBadge" },
  { name: "Employee Certifications", icon: "GraduationCap" },
  { name: "Passports & Visas", icon: "Plane" },
  { name: "AMC & Maintenance", icon: "Wrench" },
  { name: "Equipment Warranties", icon: "PackageCheck" },
  { name: "Business Licences", icon: "Building2" },
  { name: "Vendor Contracts", icon: "Handshake" },
  { name: "Domain & Hosting", icon: "Globe" },
  { name: "Software & SaaS", icon: "MonitorSmartphone" },
  { name: "Custom Categories", icon: "Sparkles" },
];

export const FEATURES = [
  {
    icon: "BellRing",
    title: "Timely reminders",
    desc: "Automatic email and push notifications before anything expires — set your own lead time per item.",
  },
  {
    icon: "LayoutDashboard",
    title: "One central dashboard",
    desc: "Every renewal across vehicles, staff, equipment and subscriptions in a single organised view.",
  },
  {
    icon: "CalendarClock",
    title: "Smart expiry tracking",
    desc: "RenewTracker watches every deadline for you and surfaces what needs attention next.",
  },
  {
    icon: "ShieldCheck",
    title: "Stay compliant",
    desc: "Avoid fines, legal issues and disruption by keeping licences and permits always up to date.",
  },
  {
    icon: "Users",
    title: "Built for teams",
    desc: "Manage renewals for the whole business — from fleet to workforce certifications.",
  },
  {
    icon: "Lock",
    title: "Secure by design",
    desc: "Your important documents and dates are kept private and protected in one secure place.",
  },
];

export const INDUSTRIES = [
  "Logistics & Fleet",
  "Construction",
  "Healthcare",
  "Manufacturing",
  "Retail & Trade",
  "Professional Services",
  "Hospitality",
  "Transport",
  "Real Estate",
  "IT & SaaS",
  "Education",
  "Agencies",
];

export const BENEFITS = [
  {
    icon: "TrendingDown",
    title: "Avoid costly oversights",
    desc: "Never pay another late penalty or fine because a renewal slipped through the cracks.",
  },
  {
    icon: "Clock",
    title: "Save hours every month",
    desc: "Stop chasing spreadsheets and sticky notes. Let automation do the tracking.",
  },
  {
    icon: "BadgeCheck",
    title: "Always audit-ready",
    desc: "Keep compliance documents organised and accessible whenever you need them.",
  },
  {
    icon: "HeartHandshake",
    title: "Peace of mind",
    desc: "Sleep easy knowing every deadline is watched and you'll be reminded in time.",
  },
];

export const WHY_CHOOSE = [
  {
    n: "01",
    title: "Everything in one place",
    desc: "Centralise renewals across vehicles, employees, equipment, licences, permits, contracts and subscriptions — no more scattered reminders.",
  },
  {
    n: "02",
    title: "Reminders that actually reach you",
    desc: "Dual email and push notifications with configurable lead times mean the right people are alerted before it's too late.",
  },
  {
    n: "03",
    title: "Made for SMBs, loved by individuals",
    desc: "Powerful enough to run a growing business, simple enough to organise your personal documents and warranties.",
  },
  {
    n: "04",
    title: "Compliance without the stress",
    desc: "Reduce risk of fines and disruption. RenewTracker keeps you consistently compliant, effortlessly.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "We manage a fleet of 40 vehicles. RenewTracker means insurance, road tax and pollution certificates are never overdue again.",
    name: "Operations Lead",
    role: "Logistics SMB",
    img: APP_SCREENSHOTS.smb_owner_1,
  },
  {
    quote:
      "Tracking staff certifications used to be a nightmare of spreadsheets. Now renewals just get flagged before they expire.",
    name: "HR Manager",
    role: "Facilities Company",
    img: APP_SCREENSHOTS.smb_owner_2,
  },
  {
    quote:
      "I use it personally for my passport, car insurance and domain renewals. Simple, clean and it just works.",
    name: "Freelance Consultant",
    role: "Individual user",
    img: null,
  },
];

export const FAQS = [
  {
    q: "What is RenewTracker?",
    a: "RenewTracker is a document renewal reminder app that helps businesses track licenses, permits, certificates, insurance, contracts, and any other document with an expiry or renewal date.",
  },
  {
    q: "What kinds of renewals can I track?",
    a: "Vehicle insurance, road tax, pollution certificates, driving licences, commercial permits, employee certifications, passports & visas, AMC & maintenance contracts, equipment warranties, business licences, vendor contracts, domain & hosting, software & SaaS subscriptions, and your own custom categories.",
  },
  {
    q: "How do reminders work?",
    a: "RenewTracker automatically tracks each expiry date and sends email and push notifications ahead of time, so you and your team stay compliant and avoid missed deadlines.",
  },
  {
    q: "Is RenewTracker only for businesses?",
    a: "No. While it's designed primarily for SMBs, it's equally useful for individuals who want to organise personal documents such as insurance, licences, passports, warranties and subscriptions.",
  },
  {
    q: "Is my data secure?",
    a: "Yes. Your renewal details and documents are stored securely and kept private. Please review our Privacy Policy for full details on how we handle data.",
  },
  {
    q: "When will the app be available?",
    a: "RenewTracker is available now on Google Play. The iOS version is coming soon to the Apple App Store — get in touch via our contact page and we'll let you know the moment it launches.",
  },
  {
    q: "How much does RenewTracker cost?",
    a: "Pricing will be announced at launch. Reach out through the contact form and we'll keep you posted on plans for businesses and individuals.",
  },
  {
    q: "How can I keep track of document expiry dates?",
    a: "Add each document and its expiry date to RenewTracker. The app helps you monitor upcoming renewals and receive reminders before important dates.",
  },
  {
    q: "Can I track any document with an expiry date?",
    a: "Yes. RenewTracker can be used for any document that has an expiry or renewal date, including licenses, permits, certificates, insurance policies, contracts, and other business documents.",
  },
  {
    q: "What types of business documents can I track?",
    a: "You can track licenses, permits, insurance, contracts, compliance certificates, and custom documents with expiry or renewal dates.",
  },
  {
    q: "Can RenewTracker remind me before a document expires?",
    a: "Yes. RenewTracker is designed to provide renewal reminders before your selected expiry or renewal date.",
  },
  {
    q: "Who can use RenewTracker?",
    a: "RenewTracker is designed for businesses and professionals who need to keep track of documents with expiry or renewal dates.",
  },
  {
    q: "Why should businesses track document expiry dates?",
    a: "Tracking expiry dates helps businesses stay organized, prepare for renewals on time, and reduce the risk of missing important renewal deadlines.",
  },
];

export const STATS = [
  { value: "14+", label: "Renewal categories" },
  { value: "2-way", label: "Email + push reminders" },
  { value: "1", label: "Secure central hub" },
  { value: "0", label: "Missed deadlines" },
];
